import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const MANIFESTO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/9cc487d1-0562-49fe-8408-0b095d1ddc37/images/a64cbe05791c2f286dafabf026ba73b6dd1dd18cda75738a7edeb8b95a5de20f.png";

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-24 sm:py-32 overflow-hidden"
    >
      {/* Background marquee — subtle, behind content */}
      <div className="absolute inset-y-0 left-0 right-0 flex flex-col justify-center gap-10 pointer-events-none select-none opacity-40">
        <Marquee speed={30} gradient={false} direction="left">
          <span className="font-display text-[14vw] leading-none tracking-tighter text-stroke pr-12">
            ENDLESS TIME — AEVUM — ENDLESS TIME — AEVUM —&nbsp;
          </span>
        </Marquee>
        <Marquee speed={20} gradient={false} direction="right">
          <span className="font-display italic text-[10vw] leading-none tracking-tight text-[#155E63]/30 pr-12">
            don't give up — don't give up — don't give up —&nbsp;
          </span>
        </Marquee>
      </div>

      <div className="relative max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-7"
          >
            <div className="relative aspect-[4/5] sm:aspect-[5/6] overflow-hidden border border-white/10">
              <img
                src={MANIFESTO_IMG}
                alt="Long exposure of an athlete in motion"
                className="absolute inset-0 w-full h-full object-cover scale-105 hover:scale-100 transition-transform duration-[1500ms]"
                data-testid="manifesto-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 text-[11px] tracking-[0.3em] uppercase text-[#F5F2EA]/80 font-bold">
                Plate II — Becoming
              </div>
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.2, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-5 md:pl-6"
          >
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#155E63] font-bold mb-6">
              Manifesto
            </p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter text-[#F5F2EA]">
              Don't give up
              <br />
              <span className="italic text-[#F5F2EA]/70">on who you</span>
              <br />
              want to be.
            </h2>

            <div className="mt-10 space-y-5 text-[#F5F2EA]/80 leading-relaxed text-base sm:text-lg font-light">
              <p>
                There is a person inside you who never stops. They wake before
                the city. They run when the weather argues. They lift the same
                weight they failed yesterday and look it in the eye.
              </p>
              <p>
                We make clothes for that person. The one you are slowly,
                stubbornly, becoming.
              </p>
            </div>

            <div className="mt-10 inline-flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase text-[#F5F2EA]/60">
              <span className="h-px w-10 bg-[#155E63]" />
              Worn by those who refuse the clock
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
